import { render } from "./wallet.vue?vue&type=template&id=23189a38&scoped=true"
import script from "./wallet.vue?vue&type=script&lang=js"
export * from "./wallet.vue?vue&type=script&lang=js"

import "./wallet.vue?vue&type=style&index=0&id=23189a38&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23189a38"]])

export default __exports__